import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { Input } from '../ui/input';  // Import component Input từ ShadCN UI
import { Button } from '../ui/button';  // Import component Button từ ShadCN UI
import { Link} from "react-router-dom"
import authService from '../../services/authService';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
// Định nghĩa schema xác thực với Zod
const schema = z.object({
  name: z.string().min(1,'Name is required'),
  email: z.string().email('Invalid email address').nonempty('Email is required'),
  password: z.string().min(6, 'Password must be at least 6 characters').nonempty('Password is required'),
});

function RegisterForm() {
  const navigate = useNavigate()
  // Sử dụng react-hook-form với Zod resolver để xác thực
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: zodResolver(schema),
  });


  const onSubmit = async (data) => {
    try {
      const res = await authService.register(data)
      toast.success('Đăng ký thành công!')
      navigate("/login")
    } catch (error) {
      toast.error('Đăng ký thất bại!')
    }

  };

  return (
    <div className="form-container space-y-4">

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div>
          <label htmlFor="name">Name</label>
          <Input
            id="name"
            type="name"
            {...register('name')}
            placeholder="Enter your name"
            className="w-full rounded-full"
          />
          {errors.name && <p className="text-red-500">{errors.name.message}</p>}
        </div>
        <div>
          <label htmlFor="email">Email</label>
          <Input
            id="email"
            type="email"
            {...register('email')}
            placeholder="Enter your email"
            className="w-full rounded-full"
          />
          {errors.email && <p className="text-red-500">{errors.email.message}</p>}
        </div>

        <div>
          <label htmlFor="password">Password</label>
          <Input
            id="password"
            type="password"
            {...register('password')}
            placeholder="Enter your password"
            className="w-full rounded-full"
          />
          {errors.password && <p className="text-red-500">{errors.password.message}</p>}
        </div>
        <div className='flex justify-between'>
          <Link className='text-primary' to={'/login'}>Login</Link>
        </div>
        <Button type="submit" className="w-full rounded-full">Register</Button>
      </form>


    </div>
  );
}

export default RegisterForm;
